import React from 'react';
import styled from 'styled-components';
import {Headline} from './headline';
import {Copy} from './copy';
import {ArrowCta, Cta} from '@hoffman/shared/src/components/Cta/cta';
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css/animate.compat.css';

interface BodyCopyProps {
  headlineSize: string;
  headlineText: string;
  copySize: string;
  copyText: string;
  blockWidth: string;
  rightSide: boolean;
  cta: boolean;
  color: string;
  link: string;
  hover: string;
  text: string;
}

export const BodyCopyBlock = ({
  headlineSize,
  headlineText,
  copySize,
  copyText,
  blockWidth,
  rightSide,
  cta,
  color,
  link,
  hover,
  text,
}: BodyCopyProps) => {
  return (
    <Container rightSide={rightSide} blockWidth={blockWidth}>
      <ScrollAnimation
        animateIn="fadeInLeft"
        animateOnce={true}
        duration={2}
        initiallyVisible={false}
        offset={50}
        delay={0}
      >
        <Headline size={headlineSize} text={headlineText} />
      </ScrollAnimation>
      <ScrollAnimation
        animateIn="fadeInLeft"
        animateOnce={true}
        duration={2}
        initiallyVisible={false}
        offset={50}
        delay={5}
      >
        <Copy text={copyText} />{' '}
      </ScrollAnimation>
      <ScrollAnimation
        animateIn="fadeInLeft"
        animateOnce={true}
        duration={2}
        initiallyVisible={false}
        offset={50}
        delay={10}
      >
        {cta && (
          <ArrowCta color={color} link={link} hover={hover} text={text} />
        )}
      </ScrollAnimation>
    </Container>
  );
};

BodyCopyBlock.defaultProps = {
  headlineSize: '50px',
  headlineText: 'Headline',
  copySize: '20px',
  copyText: 'Add Copy Text Here',
  blockWidth: '500px',
  rightSide: false,
  cta: false,
  color: 'black',
  link: 'https://google.com',
  hover: 'blue',
  text: 'Contact Us',
};

export default BodyCopyBlock;

const Container = styled.div`
  margin-left: ${(props: BodyCopyProps) => props.rightSide && 'auto'};
  margin-right: ${(props: BodyCopyProps) => props.rightSide && 0};
  max-width: ${(props: BodyCopyProps) => props.blockWidth};
  h1 {
    margin-bottom: 20px;
  }
  a {
    margin-top: 35px;
  }
`;
